<aml-language-select
  [iconOnly]="isCollapsed()"
  [currentLanguage]="currentLanguage()"
  [languageOptions]="languageOptions()"
  (languageChange)="changeLanguage($event)"
/>
